import { type ComponentPublicInstance, ref } from 'vue';

export const appHeader = ref<Element | ComponentPublicInstance | null>(null);
